<template>
    <div class="mb-10 pt-5">
        <h1 class="ucfirst display-2 mb-3">
            <a :name="group">
                {{group}}
            </a>
        </h1>
        <div v-for="command in commands" :key="command.name">
            <api-docs-command :command="command"></api-docs-command>
        </div>
    </div>
</template>

<script>
    import ApiDocsCommand from "./ApiDocsCommand";

    export default {
        name: "ApiDocsGroup",
        components: {
            ApiDocsCommand,
        },
        props: {
            config: {
                type: Array,
                required: true,
            },
            group: {
                type: String,
                required: true,
            },
        },
        computed: {
            commands() {
                let commands = [];
                this.config.map((c) => {
                    if (c.name.startsWith(`${this.group}.`)) {
                        commands.push(c);
                    }
                });

                return commands;
            },
        },

    }
</script>

<style scoped>
    .ucfirst {
        text-transform: capitalize;
    }
</style>